import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/pt-br";

dayjs.extend(updateLocale);

dayjs.updateLocale("pt-br", {
  weekdaysMin: ["D", "S", "T", "Q", "Q", "S", "S"],
});

export const formatDate = (date) => {
  if (!date) return "";

  const parsed = dayjs(date);

  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "";
};

export const formatDateTime = (date) => {
  if (!date) return "";

  const parsed = dayjs(date);

  return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : "";
};

export default dayjs;